"use client";
import { useEffect } from "react";

export default function UTMHandler() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    ["utm_source", "utm_medium", "utm_campaign", "utm_id"].forEach((key) => {
      const value = params.get(key);
      if (value) localStorage.setItem(key, value);
    });
  }, []);

  return null; // UI render nahi karega
}
